import o from "./lianshenhuabian.vue2.js";
import "./lianshenhuabian.vue3.js";
import a from "../../../../_virtual/_plugin-vue_export-helper.js";
const i = /* @__PURE__ */ a(o, [["__scopeId", "data-v-612e1749"]]);
export {
  i as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/lianshenhuabian/lianshenhuabian.vue.js
// module id = 1262
// module chunks = 67